<template>
  <div class="bg-white w-full overflow-auto h-screen">
    <div class="m-auto p-5 xl:p-0 xl:w-3/5 xl:mt-10">
      <div class="">
        <Logo
          :path="locationLogo || defaultLogo"
          width="160"
          className="flex justify-center"
          alt="CheckoutLogo"
        ></Logo>
      </div>
      <StepProgressBar :steps="3" :stepSelected="2" class="mt-8" />
      <h4 class="mt-8 text-xl font-bold">PAYMENT METHOD</h4>
      <hr />
      <CheckoutForm />
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useStore } from "vuex";

import CheckoutForm from "@/components/checkout/CheckoutForm.vue";
import StepProgressBar from "@/components/general/StepProgressBar.vue";
import Logo from "@/components/auth/Logo";

const store = useStore();

const defaultLogo = ref(require("@/assets/brain-logo.png"));
const locationLogo = computed(() => store.getters["location/getLocationLogo"]);
</script>
